import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import '../styles/Login.css';
import { login } from '../services/authService';
import Popup from '../components/Popup/Popup';
import { useApi } from '../hooks/useApi';
import logo from '../images/logo.png';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [popup, setPopup] = useState(null);
  const navigate = useNavigate();
  const { callApi } = useApi();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      navigate('/select-meal');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await callApi(() => login(username, password));
      
      if (result.success && result.data) {
        let jwtToken = result.data.access_token;
        localStorage.setItem('token', jwtToken);
        let decodedToken = jwtDecode(jwtToken);
        let user = {
          id: decodedToken.staff_id,
          code: decodedToken.staff_code,
          name: decodedToken.staff_name,
          staff_type: decodedToken.staff_type,
          staff_group_name: decodedToken.staff_group_name,
        }
        localStorage.setItem('user', JSON.stringify(user));
        navigate('/dashboard');
      } else {
        setPopup({ 
          type: 'error', 
          message: result.message || 'Đăng nhập thất bại. Vui lòng thử lại.'
        });
      }
    } catch (error) {
      console.error('Đăng nhập thất bại:', error);
      setPopup({ 
        type: 'error', 
        message: 'Đăng nhập thất bại. Vui lòng thử lại.'
      });
    }
  };

  const closePopup = () => {
    setPopup(null);
  };

  return (
    <div className="loginscr-container">
      <form className="loginscr-form" onSubmit={handleSubmit}>
        <div className="loginscr-logo-container">
          <img src={logo} alt="Logo" className="loginscr-logo" />
        </div>
        <h2 className="loginscr-title">Đăng nhập</h2>
        <div className="loginscr-form-group">
          <label className="loginscr-label" htmlFor="username">Số điện thoại:</label>
          <input
            className="loginscr-input"
            type="text"
            id="username"
            inputMode="numeric"
            pattern="[0-9]*"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="loginscr-form-group">
          <label className="loginscr-label" htmlFor="password">Mật khẩu:</label>
          <input
            className="loginscr-input"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="loginscr-button" type="submit">Đăng nhập</button>
      </form>
      {popup && (
        <Popup
          type={popup.type}
          message={popup.message}
          onClose={closePopup}
        />
      )}
    </div>
  );
}

export default Login;
